export const getSelectValue = ({ currentTarget: { value } }) => {
  return value
}